import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
const includes = ['📘 Tomo I: El Manual de Respuestas (0-6 Meses)', '📘 Tomo II: El Manual de Desarrollo (6-12 Meses)', '🎁 Bono 1: Respuestas Rápidas para Padres Agotados', '🎁 Bono 2: Organizador Semanal de Crianza', '🎁 Bono 3: Guía de Calma para Padres Primerizos', ' Acceso de por vida a todos los PDFs', '🛡️ Garantía de devolución de 7 días'];
export function OfferSection() {
  return <section id="oferta" className="py-20 px-5 text-center text-white" style={{
    background: 'linear-gradient(160deg, #0a1628 0%, #0f1e3d 100%)'
  }} data-id="element-93">
      <div className="max-w-[640px] mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-95">
          <span className="text-[0.75rem] tracking-[0.2em] uppercase text-gold mb-4 block" data-id="element-96">
            ⚠ Precio de Lanzamiento · Tiempo Limitado
          </span>
          <h2 className="font-serif text-white mb-2 text-[clamp(1.6rem,3vw,2.2rem)]" data-id="element-97">
            Accede al sistema completo ahora
          </h2>
          <p className="italic text-white/65 text-[0.95rem] mb-10" data-id="element-98">
            Cómo Entender a Tu Bebé — Manual paso a paso para padres primerizos
          </p>

          <Countdown data-id="element-99" />

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-8 max-w-[400px] mx-auto" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/tYNCNzPHQbQ935WfMx3gMW/2265f319-4af1-483d-8c5f-585e214fc786.png" alt="Cherub Agency Bundle" className="w-full h-auto drop-shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-101" />
          </motion.div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-8" data-id="element-102">
            <span className="block text-base text-white/40 line-through mb-1" data-id="element-103">
              Valor real del sistema: 97,82€
            </span>
            <span className="inline-block text-[0.8rem] text-[#6bc88a] bg-[#6bc88a]/15 py-[3px] px-2.5 rounded-full mb-4" data-id="element-104">
              Ahorras 80,85€ hoy
            </span>
            <span className="block font-bold text-gold leading-none mb-1.5 text-[clamp(3rem,7vw,4.5rem)]" data-id="element-105">
              16,97€
            </span>
            <span className="block text-[0.8rem] text-white/45" data-id="element-106">
              Pago único
            </span>

            <ul className="list-none text-left my-5 mb-7" data-id="element-107">
              {includes.map(line => <li key={line} className="py-2 pl-7 relative text-[0.92rem] text-white/80 border-b border-white/5" data-id="element-108">
                  <span className="absolute left-0 top-2 text-[#6bc88a] font-bold" data-id="element-109">
                    ✓
                  </span>
                  {line}
                </li>)}
            </ul>

            <button onClick={() => {}} className="w-full font-serif font-bold text-navy text-[1.1rem] py-5 rounded-md transition-all duration-200 hover:-translate-y-0.5" style={{
            background: 'linear-gradient(135deg, #f0c040 0%, #e8a820 100%)',
            boxShadow: '0 8px 32px rgba(240,192,64,0.35)'
          }} data-id="element-110">
              → QUIERO ENTENDER A MI BEBÉ HOY · 16,97€
            </button>

            <p className="text-[0.8rem] text-white/45 mt-4" data-id="element-111">
              🔒 Pago encriptado SSL
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}